import { render } from "./RegistrationFinish.vue?vue&type=template&id=fb553c52&scoped=true"
import script from "./RegistrationFinish.vue?vue&type=script&lang=js"
export * from "./RegistrationFinish.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=fb553c52&scoped=true&lang=css"
import "@/assets/css/user/pages/admin.css?vue&type=style&index=1&id=fb553c52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb553c52"]])

export default __exports__